import { render } from "./forgetPass.vue?vue&type=template&id=4165ae9b&scoped=true&ts=true"
import script from "./forgetPass.vue?vue&type=script&lang=ts"
export * from "./forgetPass.vue?vue&type=script&lang=ts"

import "./forgetPass.vue?vue&type=style&index=0&id=4165ae9b&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4165ae9b"]])

export default __exports__